import { render, staticRenderFns } from "./signin-oidc.vue?vue&type=template&id=05026441&scoped=true"
import script from "./signin-oidc.vue?vue&type=script&lang=js"
export * from "./signin-oidc.vue?vue&type=script&lang=js"
import style0 from "./signin-oidc.vue?vue&type=style&index=0&id=05026441&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05026441",
  null
  
)

export default component.exports